import { Caption as e, Small as t } from "../../../Typography/Typography.mjs";
import { IconChip as n, Tile as r } from "./QuickActionTile.styled.mjs";
import "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/QuickActions/components/QuickActionTile.tsx
var o = ({ action: o }) => {
	let s = o.tone ?? "default";
	return /* @__PURE__ */ a(r, {
		type: "button",
		$tone: s,
		disabled: o.disabled,
		onClick: o.onClick,
		children: [
			/* @__PURE__ */ i(n, {
				$tone: s,
				children: o.icon
			}),
			/* @__PURE__ */ i(t, {
				weight: "semibold",
				align: "center",
				color: s === "destructive" ? "error" : "primary",
				children: o.label
			}),
			o.description && /* @__PURE__ */ i(e, {
				align: "center",
				children: o.description
			})
		]
	});
};
//#endregion
export { o as QuickActionTile };
